import ConversationEffect from "src/Animations/ConversationEffect";
import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_AI_TWIN_DEMO_5 = {
  title: `The tool <span style="color: #BEE3FF;">automatically provides foresight \non campaign performance,</span> based on \nunfavorable conditions I have defined \nwith assistance from the system.`,
  subtitle: "near Real-Time Nudges & Foresights",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage(310),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(308),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "AI_TWIN/AI_Twin_04.png",
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "InfosysTopazLogo.png",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "AI_TWIN/AI_TWIN_DEMO_computer.png",
          imageStyle: {
            position: "absolute",
            right: "63.62px",
            bottom: "272px",
          },
          effect: "animate-opacity",
        },
        {
          image: "AI_TWIN/AI_TWIN_DEMO_5_bubble_1.png",
          imageStyle: {
            position: "absolute",
            right: "0px",
            bottom: "0px",
          },
        },
        {
          image: "AI_TWIN/AI_TWIN_DEMO_5_bubble_2.png",
          imageStyle: {
            position: "absolute",
            right: "0px",
            bottom: "0px",
          },
          effect: "animate-opacity",
        },
        {
          image: "AI_TWIN/AI_TWIN_DEMO_5_bubble_3.png",
          imageStyle: {
            position: "absolute",
            right: "0px",
            bottom: "0px",
          },
          effect: "animate-opacity",
        },
        {
          image: "AI_TWIN/AI_TWIN_DEMO_5_eye.png",
          imageStyle: {
            position: "absolute",
            right: "0px",
            bottom: "0px",
          },
          effect: "animate-opacity",
        },
      ]}
      pageNumber={309}
    />
  ),
};
